import React from 'react';
import NumberFormat from 'react-number-format';
import styled from 'styled-components';
import { color, gutter } from '../../styles/mixins';
import { label12, p16 } from '../../styles/typography';

const Host = styled.div`
  display: block;
  padding: 6px ${gutter(2)} 5px;
  border: ${(props) => `1px solid ${props.theme.border.color}`};
`;

const Label = styled.label`
  display: block;
  ${label12};
  line-height: 18px;
  color: ${color('gray80')};
`;

const Input = styled.input`
  ${p16};
  outline: none;
  border: none;
  display: block;
  line-height: ${gutter(3)};
  margin: 0;
  padding: 0;
  width: 100%;
  background-color: transparent;
`;

interface LabelInputProps extends React.ComponentPropsWithoutRef<'input'> {
  id: string;
  label: string;
  value: number;
  onValueChange: (values: any) => void;
}

export const LabelInput = ({
  id,
  label,
  value,
  onValueChange,
  ...rest
}: LabelInputProps) => {
  return (
    <Host>
      <Label htmlFor={id}>{label}</Label>
      <NumberFormat
        id={id}
        type="tel"
        value={value}
        thousandSeparator=","
        suffix=" USD"
        customInput={Input}
        onValueChange={onValueChange}
      />
    </Host>
  );
};
